import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';

const ADMIN_EMAIL = 'admin@swlogis.it.kr';
/** 관리자 화면 2차 잠금 (클라이언트 전용, 탭 단위) */
const ADMIN_PAGE_PASSWORD = '3500';
export const ADMIN_PAGE_UNLOCK_STORAGE_KEY = 'sw_admin_page_unlocked';

const AdminPasswordGate = ({ onSuccess }: { onSuccess: () => void }) => {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value === ADMIN_PAGE_PASSWORD) {
      try {
        sessionStorage.setItem(ADMIN_PAGE_UNLOCK_STORAGE_KEY, '1');
      } catch {
        /* ignore */
      }
      onSuccess();
      setError('');
      return;
    }
    setError('비밀번호가 올바르지 않습니다.');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f2f5',
        padding: 24,
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: '100%',
          maxWidth: 360,
          background: '#fff',
          borderRadius: 10,
          padding: 28,
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#111' }}>관리자 화면</div>
        <div style={{ fontSize: 14, color: '#666', marginBottom: 20 }}>관리자 페이지를 보려면 비밀번호를 입력하세요.</div>
        <input
          type="password"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setError('');
          }}
          placeholder="비밀번호"
          autoComplete="current-password"
          style={{
            width: '100%',
            boxSizing: 'border-box',
            fontSize: 16,
            padding: '10px 12px',
            border: '1px solid #ccc',
            borderRadius: 6,
            marginBottom: 12,
          }}
        />
        {error ? (
          <div style={{ color: '#c62828', fontSize: 13, marginBottom: 12 }}>{error}</div>
        ) : null}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={() => navigate('/', { replace: true })}
            style={{
              padding: '10px 16px',
              fontSize: 14,
              border: '1px solid #ccc',
              borderRadius: 6,
              background: '#fff',
              cursor: 'pointer',
            }}
          >
            취소
          </button>
          <button
            type="submit"
            style={{
              padding: '10px 16px',
              fontSize: 14,
              border: 'none',
              borderRadius: 6,
              background: '#1976d2',
              color: '#fff',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            확인
          </button>
        </div>
      </form>
    </div>
  );
};

const RequireAdmin = ({ children }: { children: React.ReactNode }) => {
  const user = auth.currentUser;
  const [unlocked, setUnlocked] = useState(() => {
    try {
      return sessionStorage.getItem(ADMIN_PAGE_UNLOCK_STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (!user || user.email !== ADMIN_EMAIL) {
    return <Navigate to="/" replace />;
  }

  if (!unlocked) {
    return <AdminPasswordGate onSuccess={() => setUnlocked(true)} />;
  }

  return <>{children}</>;
};

export default RequireAdmin;
